import { EValidationTestType } from '../../../utils/validationConfigs';

export const formConfig = {
  upload: {
    file: {
      model: 'upload',
      name: 'file',
      standardMessage: {},
      validationTests: [EValidationTestType.hasValue],
      visible: true,
    },
    employerId: {
      model: 'upload',
      name: 'employerId',
      standardMessage: {},
      validationTests: [EValidationTestType.hasValue],
      visible: true,
    },
  },
};
